;(function (document) {
  const rem = document.documentElement.clientWidth * 100 / 750;
  document.documentElement.style = 'font-size: ' + rem + 'px';
  document.documentElement.setAttribute('style', 'font-size: ' + rem + 'px');
})(window.document);



// WEBPACK FOOTER //
// ./src/assets/setRem.js